import { Divider, BackTop } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React from 'react';
import '../styles/Base.scss';

export default function UnescoNetworks() {
    const screen = useBreakpoint();

    return (
        <div
            className="home-content"
            style={{
                marginLeft: screen.md ? "15%" : "0%",
                maxWidth: screen.md ? "70%" : "100%"
            }}
        >
            <BackTop />

            <div
                style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "109px",
                    height: "80px",
                    marginRight: "20px",
                    marginTop: "16px"
                }}
            >
                <img
                    src="assets/unesco.png"
                    alt="logo"
                    style={{ width: "100%", height: "100%" }}
                />
            </div>

            {/* Page Title */}
            <div className="home-title">
                <div className="title">UNESCO Networks</div>
                <div className="paragraph">
                    Our Chair works actively within the global UNESCO ecosystem, engaging with partner Chairs and networks that share common missions in science, ethics, education, culture, and digital innovation. These collaborations strengthen research, capacity building, knowledge exchange, and societal impact.
                </div>
            </div>

            <Divider />

            {/* Collaborations */}
            <div className="home-title">
                <div className="title">UNESCO Chairs</div>
                <div className="paragraph">
                    we collaborate with: 
                </div>
                <div className="paragraph">
                    <ul>
                        <li>
                            <strong>UNESCO Chair in Digital Anatomy (Anatomie Numérique)</strong> – Université de Paris, Faculty of Medicine
                            <br />
                            Contact: Prof. Jean-François Uhl
                            <br />
                            Collaboration on virtual anatomy, surgical simulation, and XR-based medical training. Joint publications and workshops support the adoption of immersive technologies in clinical education and biomedical visualization.
                        </li>
                        <li>
                            <strong>UNESCO Chair in Bioethics</strong> – Universidade Católica Portuguesa, Porto
                            <br />
                            Chairholder: Prof. Mara de Freitas
                            <br />
                            Cooperation focused on ethics of technology, medical data governance, human dignity in clinical innovation, and policy frameworks for responsible AI and XR in healthcare and education.
                        </li>
                        <li>
                            <strong>UNESCO Chair on Artificial Intelligence and Human Rights</strong> – American University in Paris
                            <br />
                            <a href="https://www.aup.edu/news-events/news/2024-05-30/aup-professors-appointed-co-chairholders-unesco-chair-artificial" target="_blank" rel="noopener noreferrer">
                                Link to announcement
                            </a>
                            <br />
                            Joint activities exploring ethical AI, digital rights, governance, and the intersection of emerging technologies with societal values. Collaboration includes events, lectures, and research initiatives addressing transparency, trust, and equitable access to AI and XR tools.
                        </li>
                    </ul>
                </div>
            </div>

            <Divider />

            {/* What these collaborations enable */}
            <div className="home-title">
                <div className="title">What these collaborations enable</div>
                <div className="paragraph">
                    <ul>
                        <li>Joint research projects and scientific publications</li>
                        <li>Shared workshops, seminars, and training for students and professionals</li>
                        <li>Co-supervision of graduate students</li>
                        <li>Development of XR tools for medical and health education</li>
                        <li>Exchange of expertise on AI ethics, human rights, and responsible deployment of immersive technologies</li>
                    </ul>
                    <br />
                    These partnerships reinforce our mission to advance ethical, inclusive, and human-centered applications of AI and XR, positioning our Chair as an active contributor to UNESCO’s global network.
                </div>
            </div>
        </div>
    );
}
